import React from "react";
import { useStores } from "_common/hooks";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import i18next from "i18next";

export default function Language() {
  const {
    authStore: { setLanguage, languages, language },
  } = useStores();

  return (
    <div className="container language-page !mt-[70px]">
      <HeaderTop title={i18next.t("language")} />
      <div className="flex flex-col my-6 w-full">
        {languages?.map((item, index) => (
          <div
            className={classNames(
              "py-5 px-4 flex items-center justify-between cursor-pointer",
              {
                active: language === item?.code,
              }
            )}
            key={`item-${index.toString()}`}
            onClick={() => setLanguage(item?.code)}
          >
            <div className="flex items-center gap-4">
              <img src={item?.image} alt="" className="w-[50px]" />
              <div className="flex flex-col">
                <span className="text-[#fff] text-[14px]">{item?.text}</span>
                <span className="text-[#888888] text-[14px]">{item?.text}</span>
              </div>
            </div>
            {language === item?.code && (
              <FontAwesomeIcon icon={faCheck} size="25" color="#3D5AFE" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
